import {useEffect, useState} from 'react'
import {createPortal} from 'react-dom'

const Portal = ({children, className = 'root-portal', el = 'div'}) => {
	const [container] = useState(() => {
		return document.createElement(el)
	})

	useEffect(() => {
		container.classList.add(className)
		document.body.appendChild(container)
		return () => {
			try {
				document.body.removeChild(container)
			} catch (e) {
				console.log(e)
			}
		}
	}, [])

	return createPortal(<div onClick={e => e.stopPropagation()}>{children}</div>, container)
}

export default Portal
